import React, { useEffect } from 'react';
import { useSignUpContext, SignUpStage } from './SignUpContext';
import ProFormaQuickStart from '../ProFormaQuickStart/ProFormaQuickStart';
import BOEEstimate from '../BOEEstimate/BOEEstimate';
import ProFormaDashboard from '../ProFormaDashboard/ProFormaDashboard';

export const SignUp: React.FC = () => {
    const { currentStage, setCurrentStage, setIsDirectSignUpFlow } = useSignUpContext();

    useEffect(() => {
        setIsDirectSignUpFlow(false);
    }, [setIsDirectSignUpFlow]);

    switch (currentStage) {
        case SignUpStage.PRO_FORMA_QUICK_START:
            return <ProFormaQuickStart />;
        case SignUpStage.PRO_FORMA_DASHBOARD:
            return <ProFormaDashboard />;
        case SignUpStage.EMAIL_VERIFICATION:
            return <ProFormaDashboard />;
        case SignUpStage.ACCOUNT_CREATED:
            return <ProFormaDashboard />;
        case SignUpStage.BOE_CALCULATOR:
            return <BOEEstimate />;
        default:
            // Don't reset the stage if it's DIRECT_SIGN_UP_COMPLETED to maintain persistence.
            // When setCurrentStage(DIRECT_SIGN_UP_COMPLETED) is called,
            // this SignUp component re-renders and we want to preserve the state instead of resetting to BOE_CALCULATOR.
            if (currentStage !== SignUpStage.DIRECT_SIGN_UP_COMPLETED) {
                setCurrentStage(SignUpStage.BOE_CALCULATOR);
            }
            return <BOEEstimate />;
    }
};

export default SignUp;
